import { techReportActionTypes } from './actions';

const initialState = {
  activeContext: {
    userId: null,
    orderId: null,
    patientName: '',
    dob: null,
    age: null,
    height_cm: null,
    weight_lb: null,
    bmi: null,
    studyType: '',
    scheduledDate: null,
    openDate: null,
    priority: '',
    technicianName: '',
    referringPhysician: '',
    interpretingPhysician: '',
    startTime: null,
    endTime: null,
    locationName: '',
    roomName: '',
  },
  forms: [],
  activeTabKey: '',
  loading: false,
  saving: false,
  error: null,
};

export default function techReportReducer(state = initialState, action) {
  switch (action.type) {
    case techReportActionTypes.SET_WORK_ORDER_CONTEXT:
      return {
        ...state,
        activeContext: {
          ...state.activeContext,
          ...action.payload,
        },
      };

    case techReportActionTypes.CLEAR_WORK_ORDER_CONTEXT:
      return {
        ...state,
        activeContext: { ...initialState.activeContext },
        forms: [],
        activeTabKey: '',
        error: null,
      };

    case techReportActionTypes.SET_ACTIVE_TAB_KEY:
      return {
        ...state,
        activeTabKey: action.payload,
      };

    case techReportActionTypes.FETCH_FORMS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case techReportActionTypes.FETCH_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        forms: action.payload,
        error: null,
      };

    case techReportActionTypes.FETCH_FORMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case techReportActionTypes.SET_FORM_SAVING:
      return {
        ...state,
        saving: action.payload,
      };

    default:
      return state;
  }
}
